import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  Container
} from '@mui/material';
import { Coffee } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import { unlockNotificationAudio } from '../services/notifications';

const LoginForm = () => {
  const [deviceToken, setDeviceToken] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Если пользователь уже авторизован, перенаправляем на /orders
  useEffect(() => {
    if (isAuthenticated) {
      console.log('[LoginForm] User already authenticated, redirecting to /orders');
      navigate('/orders', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    void unlockNotificationAudio();
    setError('');

    // Валидация
    if (!deviceToken.trim()) {
      setError('Пожалуйста, введите токен устройства');
      return;
    }

    // Проверка формата токена (должен быть в формате <device_id>.<secret>)
    if (!deviceToken.includes('.')) {
      setError('Неверный формат токена. Токен должен быть в формате: <device_id>.<secret>');
      return;
    }

    setIsLoading(true);

    try {
      await login(deviceToken.trim());
      navigate('/orders');
    } catch (err) {
      setError(err.message || 'Ошибка входа. Проверьте токен устройства и попробуйте снова.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <Card sx={{ width: '100%', maxWidth: 450 }}>
          <CardContent sx={{ p: 4 }}>
            <Box display="flex" alignItems="center" justifyContent="center" mb={3}>
              <Coffee sx={{ fontSize: 40, mr: 1, color: 'primary.main' }} />
              <Typography variant="h4" component="h1">
                Quickly Coffee
              </Typography>
            </Box>
            
            <Typography variant="h6" align="center" gutterBottom>
              Вход для баристы
            </Typography>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Токен устройства"
                variant="outlined"
                value={deviceToken}
                onChange={(e) => setDeviceToken(e.target.value)}
                margin="normal"
                autoComplete="off"
                autoFocus
                disabled={isLoading}
                placeholder="1.ZwV2iVQ4pPpGqv0yC7WwXGk8R1s9Ld2b"
                helperText="Введите токен устройства в формате: <device_id>.<secret>"
              />

              <Button
                fullWidth
                type="submit"
                variant="contained"
                size="large"
                sx={{ mt: 3 }}
                disabled={isLoading}
              >
                {isLoading ? 'Вход...' : 'Войти'}
              </Button>
            </form>

            <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 2 }}>
              Токен устройства можно получить у администратора кофейни
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default LoginForm;

